import { fromEvent } from 'rxjs';
import { getAlternateTemplate } from "../services/template.service";
import { QUICKSHOP_CLOSE, QUICKSHOP_REFRESH } from '../constants/events.constants';
import { showModal } from '../services/dialog.service';
class QuickshopModal extends HTMLElement {
    static get observedAttributes() {
        return ["handle"];
    }
    constructor() {
        super();
    }
    async connectedCallback() {
        console.debug("quickshop-modal connected");
        this.quickshopRefresh$ = fromEvent(window, QUICKSHOP_REFRESH, (e) => {
            this.setAttribute("handle", e.detail.handle);
        }).subscribe();
    }
    async attributeChangedCallback(name, oldValue, newValue) {
        console.debug("quickshop-modal attribute changed");
        if (oldValue === newValue)
            return;
        switch (name) {
            case 'handle':
                this.cleanupScripts();
                this.render(newValue);
                break;
            default:
                break;
        }
    }
    disconnectedCallback() {
        console.debug("quickshop-modal disconnected");
        if (this.quickshopRefresh$) {
            this.quickshopRefresh$.unsubscribe();
        }
        this.cleanupScripts();
    }
    cleanupScripts() {
        const addedScripts = document.querySelectorAll('.quickshop-added');
        addedScripts.forEach(s => s.remove());
    }
    async render(handle) {
        const quickshopTemplate = await getAlternateTemplate(`/products/${handle}`, 'quickshop');
        const doc = new DOMParser().parseFromString(quickshopTemplate, 'text/html');
        const allNodes = [...Array.from(doc.head.childNodes), ...Array.from(doc.body.childNodes)]
            .sort(loadScriptsFirst)
            .map(node => {
            if (node.nodeName === 'SCRIPT') {
                // browsers prevent XSS attacks by not running scripts loaded through requests; so we need to reload these
                const scriptEl = document.createElement('script');
                scriptEl.classList.add('quickshop-added');
                const src = node.src;
                if (src) {
                    scriptEl.src = src;
                }
                else {
                    scriptEl.textContent = node.textContent;
                }
                return scriptEl;
            }
            else {
                return node;
            }
        });
        this.innerHTML = '';
        this.append(...allNodes);
    }
}
if (!window.customElements.get("quickshop-modal")) {
    customElements.define("quickshop-modal", QuickshopModal);
}
class QuickshopCTA extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('click', (e) => {
            e.preventDefault();
            const quickshopModalEl = document.createElement('quickshop-modal');
            // eslint-disable-next-line wc/no-constructor-attributes
            quickshopModalEl.setAttribute('handle', this.dataset.handle || '');
            const dialogWrapper = showModal(quickshopModalEl, { classes: 'quickshop' });
            window.addEventListener(QUICKSHOP_CLOSE, () => {
                dialogWrapper.close();
            }, { once: true });
        });
    }
    connectedCallback() {
        this.innerHTML = `<button class="quickshop-v2">Quick Shop</button>`;
    }
}
if (!window.customElements.get("quickshop-cta")) {
    customElements.define("quickshop-cta", QuickshopCTA);
}
function loadScriptsFirst(a, b) {
    return a.nodeName === 'SCRIPT' ? -1 : b.nodeName === 'SCRIPT' ? 1 : 0;
}
